import React, { useRef, useState } from 'react';
import { Button, Input, Space, Table } from 'antd';
import { withCsrTable } from './hooks';
const CsrTable = props => {
  const { columns, data, ...config } = props;
  return <Table columns={columns} dataSource={data} {...config} />;
};
export default withCsrTable(CsrTable);
